import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { inject } from "vue";
import CheckoutMove from "./checkout/move/checkoutMove.vue";
import CheckoutPc from "./checkout/pc/checkoutPc.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Methods',
  setup(__props) {

const isMove = inject<boolean>("isMove") || false;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(isMove) ? CheckoutMove : CheckoutPc)))
}
}

})